/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_jf_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free JSON formatter, validator and minifier. Beautify or minify JSON with custom indentation, and catch syntax errors instantly. Works in your browser.`)
};

const es_jf_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formateador, validador y minificador JSON gratuito. Embellecer o minificar JSON con indentación personalizada, y detectar errores de sintaxis al instante. Funciona en tu navegador.`)
};

const de_jf_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser JSON-Formatter, Validator und Minimizer. Formatieren oder minimieren Sie JSON mit benutzerdefiniertem Einzug, und erkennen Sie Syntaxfehler sofort. Funktioniert in Ihrem Browser.`)
};

const nl_jf_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis JSON formatter, validator en minimaliseerder. Maak JSON mooi of minimaliseer het met aangepaste inspringing, en vang syntaxisfouten onmiddellijk op. Werkt in je browser.`)
};

const fr_jf_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formateur JSON gratuit, validateur et minificateur. Embellissez ou minifiez JSON avec une indentation personnalisée et détectez instantanément les erreurs de syntaxe. Fonctionne dans votre navigateur.`)
};

const it_jf_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formattatore, validatore e minimizzatore JSON gratuito. Formatta o minimizza JSON con indentazione personalizzata e cattura gli errori di sintassi istantaneamente. Funziona nel tuo browser.`)
};

const pt_br2_jf_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formatador, validador e minificador JSON gratuito. Embeleze ou minifique JSON com indentação personalizada e detecte erros de sintaxe instantaneamente. Funciona no seu navegador.`)
};

const pt_jf_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formatador, validador e minificador de JSON gratuito. Embeleze ou minifique JSON com indentação personalizada e detete erros de sintaxe instantaneamente. Funciona no seu navegador.`)
};

const ja_jf_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料のJSONフォーマッター、バリデーター、minifier。カスタムインデンテーション、2スペース、4スペース、またはタブでJSONをbeautifyまたはminifyし、構文エラーをすぐにキャッチします。ブラウザで動作します。`)
};

const zh_jf_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费的 JSON 格式化、验证与压缩工具。使用自定义缩进美化或压缩 JSON，并即时捕捉语法错误。全程在您的浏览器中运行。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const jf_tool_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.jf_tool_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("jf_tool_description", locale)
	if (locale === "en") return en_jf_tool_description(inputs)
	if (locale === "es") return es_jf_tool_description(inputs)
	if (locale === "de") return de_jf_tool_description(inputs)
	if (locale === "nl") return nl_jf_tool_description(inputs)
	if (locale === "fr") return fr_jf_tool_description(inputs)
	if (locale === "it") return it_jf_tool_description(inputs)
	if (locale === "pt-BR") return pt_br2_jf_tool_description(inputs)
	if (locale === "pt") return pt_jf_tool_description(inputs)
	if (locale === "ja") return ja_jf_tool_description(inputs)
	return zh_jf_tool_description(inputs)
};